import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Linkedin, Twitter, Facebook } from "lucide-react";
import { COMPANY } from "@/data/content";

const QUICK = [
  { label: "Le CPE", href: "/#cpe" },
  { label: "Décret Tertiaire", href: "/#decret" },
  { label: "Les CEE", href: "/#cee" },
  { label: "Travaux finançables", href: "/#travaux" },
  { label: "Simulateur", href: "/#simulateur" },
  { label: "Contact", href: "/#contact" },
];

export default function Footer() {
  return (
    <footer className="bg-[#F4F8EC] border-t-4 border-emerald text-midnight" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-16 w-16 bg-white rounded-md p-1 flex items-center justify-center border border-slate-200 shadow-sm">
                <img src="/logo.jpg" alt="Logo PRIMEC2E CEE" className="h-full w-full object-contain" />
              </span>
              <span className="font-display font-black text-2xl">{COMPANY.name}</span>
            </div>
            <p className="text-slate-600 text-sm leading-relaxed">{COMPANY.baseline}.</p>
            <div className="flex gap-3 mt-6">
              {[Linkedin, Twitter, Facebook].map((Icon, i) => (
                <a key={i} href="#" className="h-9 w-9 border border-slate-300 flex items-center justify-center text-midnight hover:bg-emerald hover:border-emerald hover:text-white transition-colors" aria-label="réseau social">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="overline text-emerald mb-5">Liens rapides</h4>
            <ul className="space-y-3">
              {QUICK.map((q) => (
                <li key={q.label}>
                  <a href={q.href} className="text-slate-600 text-sm hover:text-emerald transition-colors">{q.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="overline text-emerald mb-5">Contact</h4>
            <ul className="space-y-4 text-sm text-slate-600">
              <li className="flex gap-3"><MapPin className="h-4 w-4 text-emerald shrink-0 mt-0.5" /><span>{COMPANY.addressFull}</span></li>
              <li className="flex gap-3"><Phone className="h-4 w-4 text-emerald shrink-0 mt-0.5" /><a href={`tel:${COMPANY.phoneRaw}`} className="hover:text-emerald">{COMPANY.phone}</a></li>
              <li className="flex gap-3"><Mail className="h-4 w-4 text-emerald shrink-0 mt-0.5" /><a href={`mailto:${COMPANY.email}`} className="hover:text-emerald">{COMPANY.email}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="overline text-emerald mb-5">Informations</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/mentions-legales" className="text-slate-600 hover:text-emerald transition-colors">Mentions légales</Link></li>
              <li><Link to="/politique-confidentialite" className="text-slate-600 hover:text-emerald transition-colors">Politique de confidentialité</Link></li>
              <li><a href="/#contact" className="text-slate-600 hover:text-emerald transition-colors">Nous contacter</a></li>
              <li><Link to="/blog" className="text-slate-600 hover:text-emerald transition-colors">Actualités</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} {COMPANY.name}. Tous droits réservés.</p>
          <p>Performance énergétique · CPE · Décret Tertiaire · CEE</p>
        </div>
      </div>
    </footer>
  );
}
